import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global Fetch Interceptor to prevent Caching and ensure real-time data
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  let [resource, config] = args;

  // If it's a string URL and contains our backend API path
  if (typeof resource === 'string' && resource.includes('backend/api')) {
    // 1. Add Cache Buster (timestamp) to URL
    const separator = resource.includes('?') ? '&' : '?';
    // Optimized: Only bust and add no-cache headers for GET requests
    if (!config || !config.method || config.method.toUpperCase() === 'GET') {
      resource = `${resource}${separator}_cb=${Date.now()}`;

      config = config || {};
      config.headers = {
        ...config.headers,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      };
    }
  }

  return originalFetch(resource, config);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


// heyy im chirag 
